﻿export class UpdatePasswordModel {
    Id: number = 0;
    OldPassword: string = "";
    NewPassword: string = "";
    ConfirmPassword: string = "";
    Mcd: string = "";
}